export default __webpack_public_path__ + "static/media/category1.6ddf175e.png";